import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Input,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardStockManagementTabAddUX = (props: any) => {
    return(
      <div
        id="CardStockManagementTabAddUX-div-0"
        style={{width:"100%", padding: "10px",  height: "100%"}}>
        <div
          className="ui form"
          id="CardStockManagementTabAddUX-div-1"
          style={{marginBottom: "1rem"}}>
          
        </div>
        <div
          className="ui form"
          id="CardStockManagementTabAddUX-div-3">
          
          <FormGroup
            id="CardStockManagementTabAddUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardStockManagementTabAddUX-FormField-5"
              inline={true}>
              <label
                id="CardStockManagementTabAddUX-label-11"
                style={{minWidth: "fit-content"}}>
                {props.languageUX === "en" ? "Product" : "สินค้า"}
              </label>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-6"
              inline={true}
              width={3}>
              <Input
                fluid={true}
                id="CardStockManagementTabAddUX-Input-12"
                readOnly={true}
                ref={(ref) => ref && (ref.inputRef.current.style.backgroundColor = "#DFDFDF",ref.inputRef.current.style.borderColor = "#DBDBDB")}
                style={{width: "100%"}}
                value={props.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-7"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-20"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-22"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Add products to" : "เติมสินค้าไปยัง"}
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-23"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-8"
              inline={true}>
              <Dropdown
                disabled={props.readOnly || false}
                id="CardStockManagementTabAddUX-Dropdown-65"
                name="storage"
                onChange={props.onChangeValue}
                options={props.storageOptions || []}
                selection={true}
                value={props.detail?.storage || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-24"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-26"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-27"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Bin Location" : "Bin Location"}
                  <label
                    id="CardStockManagementTabAddUX-label-2"
                    style={{fontWeight: "bold", fontSize: "1.1rem"}}>
                    {props.languageUX === "en" ? "Restocking" : "เติมสินค้า"}
                  </label>
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-28"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-25"
              inline={true}>
              <Input
                disabled={props.readOnly || false}
                id="CardStockManagementTabAddUX-Input-29"
                name="bin_location"
                onChange={props.onChangeValue}
                value={props.detail?.bin_location || ""}>
              </Input>
            </FormField>
            <div
              className="field inline"
              id="CardStockManagementTabAddUX-div-19"
              style={{flex: 1}}>
              
            </div>
            <FormField
              id="CardStockManagementTabAddUX-FormField-9"
              inline={true}>
              <Button
                color={Number.isInteger(props.detail?.index) ? "yellow" : "green"}
                disabled={props.disabledAdd || false}
                id="CardStockManagementTabAddUX-Button-16"
                onClick={props.onAdd}>
                {Number.isInteger(props.detail?.index) ? "แก้ไขรายการ" : "เพิ่มรายการ"}
              </Button>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-10"
              inline={true}>
              <Button
                color="yellow"
                disabled={props.readOnly || false}
                id="CardStockManagementTabAddUX-Button-17"
                onClick={props.onClear}>
                {props.languageUX === "en" ? "clear" : "เคลียร์"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardStockManagementTabAddUX-FormGroup-30"
            inline={true}>
            <FormField
              id="CardStockManagementTabAddUX-FormField-31"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-39"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-47"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Lot No." : "ล็อตที่"}
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-48"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-32"
              inline={true}
              width={3}>
              <Dropdown
                allowAdditions={true}
                disabled={props.readOnly || false}
                fluid={true}
                id="CardStockManagementTabAddUX-Dropdown-40"
                name="lot_no"
                onAddItem={props.onAddItemLotNo}
                onChange={props.onChangeValue}
                options={props.lotNoOptions || []}
                search={true}
                selection={true}
                style={{width:"100%"}}
                value={props.detail?.lot_no || ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-33"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-41"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-49"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Expiry date" : "วันหมดอายุ"}
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-50"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-34"
              inline={true}
              width={3}>
              <DateTextBox
                disabled={props.readOnly || props.disabledExpireDate || false}
                id="CardStockManagementTabAddUX-DateTextBox-42"
                onChange={props.onChangeDate("expire_date")}
                value={props.expireDate || ""}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-35"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-43"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-51"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Top-up amount" : "จำนวนเติม"}
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-52"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-36"
              inline={true}
              width={2}>
              <Input
                disabled={props.readOnly || false}
                fluid={true}
                id="CardStockManagementTabAddUX-Input-44"
                name="quantity"
                onChange={props.onChangeValue}
                style={{width:"100%"}}
                type="number"
                value={props.detail?.quantity || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-37"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-45"
                style={{display: "flex"}}>
                
                <label
                  id="CardStockManagementTabAddUX-label-53"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Refill products from" : "เติมสินค้าจาก"}
                </label>
                <label
                  id="CardStockManagementTabAddUX-label-54"
                  style={{color: "red"}}>
                  *
                </label>
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-38"
              inline={true}
              width={3}>
              <Dropdown
                allowAdditions={false}
                disabled={props.readOnly || false}
                fluid={true}
                id="CardStockManagementTabAddUX-Dropdown-46"
                name="reference_text"
                onAddItem={props.onAddItemFrom}
                onChange={props.onChangeValue}
                options={props.fromOptions || []}
                search={true}
                selection={true}
                style={{width:"100%"}}
                value={props.detail?.reference_text || ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardStockManagementTabAddUX-div-55">
          
          <Table
            data={props.productItems || []}
            getTrProps={props.getTrProps}
            headers="รหัสสินค้า,ชื่อ,Product type,Lot No.,Expiry Date,เติมสินค้าไปยัง,เติมสินค้าจาก,จำนวนเติม,แก้ไข/ลบ"
            id="CardStockManagementTabAddUX-Table-56"
            keys="code,name,type,lot_no,expire_date,storage,reference_text,quantity,action"
            minRows={5}
            showPagination={false}
            style={{height: "250px"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardStockManagementTabAddUX-div-57"
          style={{marginTop: "1rem"}}>
          
          <FormGroup
            id="CardStockManagementTabAddUX-FormGroup-58"
            inline={true}>
            <div
              className="field inline"
              id="CardStockManagementTabAddUX-div-62"
              style={{flex: 1}}>
              
            </div>
            <FormField
              id="CardStockManagementTabAddUX-FormField-60"
              inline={true}>
              <div
                id="CardStockManagementTabAddUX-div-66">
                {props.ButtonConfirm}
              </div>
            </FormField>
            <FormField
              id="CardStockManagementTabAddUX-FormField-61"
              inline={true}>
              <Button
                color="red"
                disabled={props.disabledCancel|| false}
                id="CardStockManagementTabAddUX-Button-64"
                onClick={props.onCancel}>
                {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
              </Button>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}

CardStockManagementTabAddUX.displayName = "CardStockManagementTabAddUX";
export default React.memo(CardStockManagementTabAddUX)

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"10px\",  height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "เติมสินค้า",
          "valueEN": "Restocking"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "สินค้า",
          "valueEN": "Product"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-11"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"fit-content\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Input",
      "parent": 6,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Input-12"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "ref": {
          "type": "code",
          "value": "(ref) => ref && (ref.inputRef.current.style.backgroundColor = \"#DFDFDF\",ref.inputRef.current.style.borderColor = \"#DBDBDB\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.name || \"\""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "Number.isInteger(props.detail?.index) ? \"แก้ไขรายการ\" : \"เพิ่มรายการ\""
        },
        "color": {
          "type": "code",
          "value": "Number.isInteger(props.detail?.index) ? \"yellow\" : \"green\""
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAdd || false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Button-16"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAdd"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field inline"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "เติมสินค้าไปยัง",
          "valueEN": "Add products to"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "Bin Location",
          "valueEN": "Bin Location"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Input",
      "parent": 25,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Input-29"
        },
        "name": {
          "type": "value",
          "value": "bin_location"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "ref": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.detail?.bin_location || \"\""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormGroup-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-34"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 30,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 30,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Dropdown",
      "parent": 32,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Dropdown-40"
        },
        "name": {
          "type": "value",
          "value": "lot_no"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddItemLotNo"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.lotNoOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.lot_no || \"\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 42,
      "name": "DateTextBox",
      "parent": 34,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly || props.disabledExpireDate || false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-DateTextBox-42"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate(\"expire_date\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.expireDate || \"\""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Input",
      "parent": 36,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Input-44"
        },
        "name": {
          "type": "value",
          "value": "quantity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.quantity || \"\""
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Dropdown",
      "parent": 38,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Dropdown-46"
        },
        "name": {
          "type": "value",
          "value": "reference_text"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddItemFrom"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.fromOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.reference_text || \"\""
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ล็อตที่",
          "valueEN": "Lot No."
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-47"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-48"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "วันหมดอายุ",
          "valueEN": "Expiry date"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนเติม",
          "valueEN": "Top-up amount"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-52"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "เติมสินค้าจาก",
          "valueEN": "Refill products from"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-53"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-label-54"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 56,
      "name": "Table",
      "parent": 55,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.productItems || []"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.getTrProps"
        },
        "headers": {
          "type": "value",
          "value": "รหัสสินค้า,ชื่อ,Product type,Lot No.,Expiry Date,เติมสินค้าไปยัง,เติมสินค้าจาก,จำนวนเติม,แก้ไข/ลบ"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Table-56"
        },
        "keys": {
          "type": "value",
          "value": "code,name,type,lot_no,expire_date,storage,reference_text,quantity,action"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"250px\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormGroup",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormGroup-58"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field inline"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Button",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledCancel|| false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Button-64"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly || false"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-Dropdown-65"
        },
        "name": {
          "type": "value",
          "value": "storage"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.storageOptions || []"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.detail?.storage || \"\""
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardStockManagementTabAddUX-div-66"
        }
      },
      "seq": 66,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardStockManagementTabAddUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
